module.exports = __webpack_public_path__ + "img/wind.e2c3bd71.svg";